import * as React from "react";
import TextInput from "./TextInput";
import sfetch from "../../../utils/super-fetch";
import { fillTemplateString, getLocalePrice } from "../../../utils/text-rendering";
import { CouponFrequency } from "../../../model/pricing/CouponFrequency";
import Coupon from "../../../model/pricing/Coupon";
import AsyncAction from "../../../../AsyncAction";

interface CouponInputProps {
  validateEndpoint: string;
  priceExcludingTaxInCents: number;
  currency: string;
  discountPrice: number;
  coupon?: Coupon;
  onApplyCoupon: (coupon: Coupon) => void;
  setErrorMsg: (msg: string) => void;
}

interface CouponInputState {
  fillingCoupon: boolean;
  couponInputValue?: string;
}

export default class CouponInput extends React.PureComponent<CouponInputProps, CouponInputState> {
  constructor(props: CouponInputProps) {
    super(props);
    this.state = { fillingCoupon: false };
    this.validateCoupon = this.validateCoupon.bind(this);
  }

  render() {
    return (
      <div className="coupon-input">
        {!this.props.coupon ? (
          <>
            {!this.state.fillingCoupon ? (
              <div
                id="apply-coupon-link"
                className="link"
                onClick={() => this.setState({ fillingCoupon: true })}
              >
                {i18n["Form.DoctorRegistration.Payment.Billing.ApplyCoupon"]}
              </div>
            ) : (
              <div className="h-flex input-group with-margins">
                <div className="coupon-input">
                  <TextInput
                    name="coupon"
                    label={i18n["Global.Coupon"]}
                    detail={i18n["Global.OptionalField"]}
                    onChange={(inputState) => this.setState({ couponInputValue: inputState.value })}
                  />
                </div>
                <div className="coupon-submit">
                  <AsyncAction
                    buttonId="coupon-submit"
                    buttonType="button-secondary"
                    promise={this.validateCoupon}
                    disabled={
                      !this.state.couponInputValue || this.state.couponInputValue.length == 0
                    }
                    buttonLabel={i18n["Global.Apply"]}
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="h-flex space-between no-wrap">
            <div>
              <div id="coupon-description">
                {this.props.coupon.name}&nbsp;
                <span
                  className="link"
                  onClick={() =>
                    this.setState({ fillingCoupon: true }, () => this.props.onApplyCoupon(null))
                  }
                >
                  {i18n["Form.DoctorRegistration.Payment.Billing.ChangeCoupon"]}
                </span>
              </div>
              {this.props.coupon.frequency == CouponFrequency.MONTHLY &&
                this.props.coupon.durationInMonth && (
                  <div className="discount-duration-info">
                    {i18n["Form.DoctorRegistration.Payment.Billing.CouponPeriod"]}
                    &nbsp;
                    {fillTemplateString(i18n["Form.DoctorRegistration.Payment.Billing.XMonths"], {
                      x: this.props.coupon.durationInMonth.toString(),
                    })}
                    .
                  </div>
                )}
              {this.props.coupon.frequency == CouponFrequency.ONCE && (
                <div className="discount-duration-info">
                  {i18n["Form.DoctorRegistration.Payment.Billing.CouponOnce"]}
                </div>
              )}
            </div>
            <div>-{getLocalePrice(this.props.discountPrice, this.props.currency)}</div>
          </div>
        )}
      </div>
    );
  }

  private validateCoupon(): Promise<any> {
    this.props.setErrorMsg(null);
    return sfetch(this.props.validateEndpoint, {
      method: "PUT",
      body: JSON.stringify({
        payment: {
          coupon: this.state.couponInputValue,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        response.json().then((result) =>
          this.setState(
            {
              fillingCoupon: false,
            },
            () => this.props.onApplyCoupon(result.coupon)
          )
        );
      })
      .catch((e) => {
        if (e.status == 400) {
          this.props.setErrorMsg(i18n["Form.DoctorRegistration.Error.CouponInvalid"]);
        } else {
          this.props.setErrorMsg(i18n["Form.DoctorRegistration.Error.CouponError"]);
        }
        this.props.onApplyCoupon(null);
        throw e;
      });
  }
}
